import styled from "styled-components";

export const WalletLogsHeaderWrapper = styled.div`
  padding: 20px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const WalletLogsHeaderValue = styled.div`
  display: flex;
  flex-direction: column;
  color: #121212;
  gap: 5px;

  > .title {
    font-weight: 400;
    font-size: 15px;
  }

  > .point {
    font-weight: 700;
    font-size: 20px;
    display: flex;
    gap: 5px;
  }
`;

export const WalletLogsHeaderFilterWrapper = styled.div``;
